import { combineReducers } from "@reduxjs/toolkit";
import viewDataPageReducer from "./viewDataPage";

const viewDataReducers = combineReducers({
  viewDataPage: viewDataPageReducer,
});

export default viewDataReducers;
